export const release = 'fa36c731ffb78921faaa8e8b5805991003d4872a';
